































































import { ValidationObserver } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';
import Vue from 'vue';

import NavItem from '@/web/components/navigation/NavItem.vue';

export default Vue.extend({
  components: {
    ValidationObserver,
    NavItem,
  },
  data() {
    return {
      inProgress: false,
      password: '',
      password_repeat: '',
      formError: null,
      passwordReset: false,
    };
  },
  methods: {
    async resetPassword() {
      this.inProgress = true;
      try {
        const data = {
          new_password1: this.password_repeat,
          token: this.$route.params.token,
          uid: this.$route.params.uid,
        };

        await this.$store.dispatch('user/resetConfirm', data);
        this.passwordReset = true;
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
        this.$refs.form.setErrors(errorToMessage(error.response));
      }
      this.inProgress = false;
    },
  },
});
